var exports = {
  "a": "Box__Rot444",
};

module.exports = exports;
